import { render, staticRenderFns } from "./RangeIndicatorForm.vue?vue&type=template&id=c20828fa&"
import script from "./RangeIndicatorForm.vue?vue&type=script&lang=js&"
export * from "./RangeIndicatorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports